import { AppState } from 'Store'

export const templateSelectors = {
	getList: (state: AppState) => state.adminSlice.template.list.entries,
	getTotal: (state: AppState) => state.adminSlice.template.list.total_entries,
	getParams: (state: AppState) => state.adminSlice.template.requestParams,
	getLoading: (state: AppState) => state.adminSlice.template.isLoading,
	getOne: (state: AppState) => state.adminSlice.template.currentTemplate,
}
